import { Table, TableBody, TableCell, TableRow } from '@material-ui/core'

import { useGetDiagnosisById } from '@/hooks/queries/use-get-diagnosis-by-id'
import { Culture, CultureLabel } from '@/types/culture'
import { Treatment, TreatmentLabel } from '@/types/treatment'

import { LoadingConfirmStep } from '../loading-confirm-step'
import { useStyles } from './style'

export interface DiagnosisSummaryProps {
  diagnosis: {
    id: string
    culture: Culture
    treatment: Treatment
  }
}

export function DiagnosisSummary({ diagnosis }: DiagnosisSummaryProps) {
  const classes = useStyles()

  const { data } = useGetDiagnosisById(
    diagnosis.treatment,
    diagnosis.culture,
    diagnosis.id,
  )

  if (!data) {
    return <LoadingConfirmStep />
  }

  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableBody className={classes.body}>
          <TableRow>
            <TableCell component='th' colSpan={2}>
              Nome do diagnóstico:
            </TableCell>
            <TableCell colSpan={2} align='right'>
              {data.demandName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component='th' colSpan={2}>
              Diagnósatico:
            </TableCell>
            <TableCell colSpan={2} align='right'>
              {TreatmentLabel[data.treatment]}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component='th'>Cultura:</TableCell>
            <TableCell align='right'>{CultureLabel[data.culture]}</TableCell>
            <TableCell component='th'>Responsável:</TableCell>
            <TableCell align='right'>{data.username}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component='th'>Projeto:</TableCell>
            <TableCell align='right'>{data.project.name}</TableCell>
            <TableCell component='th'>Região:</TableCell>
            <TableCell align='right'>Não selecionada</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component='th'>Área a ser analisada aprox.:</TableCell>
            <TableCell align='right'>
              {data.perimeter.area.toFixed(3)} ha
            </TableCell>
            <TableCell component='th'>Data do voo:</TableCell>
            <TableCell align='right'>{data.flightDateLabel}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component='th'>Atividade:</TableCell>
            <TableCell align='right'>Pulverização</TableCell>
            <TableCell colSpan={2} />
          </TableRow>
        </TableBody>
      </Table>
    </div>
  )
}
